import { render, staticRenderFns } from "./pageDiagnosis3.vue?vue&type=template&id=63b2f5f2&scoped=true"
import script from "./pageDiagnosis3.vue?vue&type=script&lang=js"
export * from "./pageDiagnosis3.vue?vue&type=script&lang=js"
import style0 from "./pageDiagnosis3.vue?vue&type=style&index=0&id=63b2f5f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2f5f2",
  null
  
)

export default component.exports